import { render, staticRenderFns } from "./platapply.vue?vue&type=template&id=56304766&"
import script from "./platapply.vue?vue&type=script&lang=js&"
export * from "./platapply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports